import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invalidFrom: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.invalid-from',
		defaultMessage: 'From date must be valid date',
		description: 'Input label to select from date.',
	},
	invalidTo: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.invalid-to',
		defaultMessage: 'To date must be valid date',
		description: 'Input label to select to date.',
	},
	futureStartDateValidationMessage: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.future-start-date-validation-message',
		defaultMessage: 'From date must not be after {date}',
		description: 'validation message displayed when user selects future From date',
	},
	futureEndDateValidationMessage: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.future-end-date-validation-message',
		defaultMessage: 'To date must not be after {date}',
		description: 'validation message displayed when user selects future To date',
	},
	maxFromDateExceededMessage: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.max-from-date-exceeded-message',
		defaultMessage: 'From date range cannot be longer than {date}',
		description:
			'validation message displayed when user selected From date is older than specified date',
	},
	fromDateExceededMessage: {
		id: 'servicedesk-reports-common.date-filter.date-picker-group.connected-date-pickers-with-validator.utils.from-date-exceeded-message',
		defaultMessage: 'From date must be before To date',
		description: 'validation message displayed when user selected To date is older than From date',
	},
});
